import React from "react";
import { menuIcon } from "./menuIcons";

/** A tile that opens a page (level-2 menu) or a section (on the home page). */
const MenuCard = ({ menuItem, onClick }) => (
  <div className="col-xxl-3 col-lg-4 col-sm-6">
    <button type="button" className="menu-tile" onClick={onClick}>
      <span className="menu-tile__icon" aria-hidden="true">
        <i className={`bi ${menuIcon(menuItem)}`} />
      </span>
      <span className="menu-tile__name">{menuItem}</span>
      <i className="bi bi-chevron-right menu-tile__go" aria-hidden="true" />
    </button>
  </div>
);

export default MenuCard;
